
var apiUrl = "https://wx.izcare.cn/api/";//本地开发
var appid = "wxb30cee14fa350958";
var scopeBase = "snsapi_base";
var scopeUserInfo = "snsapi_userinfo";
var codeUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid={appid}&redirect_uri={url}&response_type=code&scope={scope}&state=1#wechat_redirect";//

var outsideModel = {};
outsideModel.getInit = function(){
  console.log("getInit");

  var ref = false;
  if(GetQueryString("userInfoAuthorization") == "1"){
    return true;
  }
   $.ajax({
    type: 'POST',
    url: apiUrl + "common/getExistOpenId",
    xhrFields: {
      withCredentials: true
    },
    crossDomain: true,
    async:false, 
    success: function (data) {
      console.log("getInit code="+data.code);
      if(data.code == 200){
        console.log("getInit type="+1+data.code);
        var session = window.sessionStorage.getItem('logNum');
        if(session == null){
          $.ajax({
            type: 'POST',
            url: apiUrl + "common/getOpenIdSession",
            xhrFields: {
              withCredentials: true
            },
            crossDomain: true,
            async:false, 
            success: function (res) {
              if(res.code == 200){
                console.log("存储session开始");
                if(res.data != null){
                  window.sessionStorage.setItem("logNum",res.data);
                }
                console.log("存储session结束");
              }
            }
          });
        }
        ref = true;
      }else if(data.code != 200 && GetQueryString("code") == null){
        console.log("getInit type="+2+data.code);
        var url = window.location.href;
        url = url.replace("&","%26").replace("&","%26").replace("&","%26").replace("&","%26").replace("&","%26");
        document.body.style = "display: none; position: absolute; top: 0%; left: 0%; width: 100%; height: 100%; background-color: ffffff; z-index:1001; -moz-opacity: 0.7; opacity:.70; filter: alpha(opacity=70);";
        window.location.href = codeUrl.replace("{appid}", appid).replace("{scope}", scopeBase).replace("{url}", url);
        ref = false;
      }else if(data.code != 200 && GetQueryString("code") != null){
        console.log("getInit type="+3+data.code);
        $.ajax({
          type: 'POST',
          url: apiUrl + "common/getCodeOpenId",
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          async:false, 
          data : {
            code : GetQueryString("code"),
            coreId : GetQueryString("coreId")
          },
          success: function (res) {
            if(res.code == 200){
              console.log("getInit type="+3+res.code);
              // alert(a.data);
              ref = true;
              console.log("存储session开始");
              if(res.data != null){
                window.sessionStorage.setItem("logNum",res.data);
              }
              console.log("存储session结束");
            }else if(res.code == 105){
              console.log("getInit type="+4+res.code);
              var localUrl = GetLocalhostUrl();  
              window.location.href = codeUrl.replace("{appid}", appid).replace("{scope}", scopeBase).replace("{url}", encodeURI(localUrl));
              ref = false;
            }
          }
        });
      }else{
        ref = false;
      }
    }
  });

  return ref;
}

outsideModel.getUserInfoAuthorization = function(){
  var url = GetLocalhostUrl();
  if(url.indexOf("?") != -1){
    url += "&userInfoAuthorization=1";
  }else{
    url += "?userInfoAuthorization=1";
  }
  window.location.href = codeUrl.replace("{appid}", appid).replace("{scope}", scopeUserInfo).replace("{url}", encodeURI(url));
}

outsideModel.apiUrl = apiUrl;


function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null){
        return decodeURI(r[2]);
    }
    return null;
}

function GetLocalhostUrl(){
  var url = window.location.href;
  if(url.indexOf("code") != 0){
    url = url.substring(0, url.indexOf("code"));
    url = url.replace("code","");
    if(url.charAt(url.length - 1) == "?" || url.charAt(url.length - 1) == "&"){
      url = url.substring(0, url.length - 1);
    }
  };
  return url;
}
function isAuthorization(){//获取用户是否授权
  console.log('授权')
    let self = this;
    if(self.userInfoAuthorization == "1"){
      $.ajax({
        url: apiUrl+'common/updateAuthenticationUserInfo',
        type: 'post',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data :{
          code : self.codes
        },
        success: (res)=>{
          console.log("更新授权信息" + res);
          if(res.code == 200){
            // this.gettoken();
          }
        },
        error:(e)=>{
          console.log(e);
        }
      })
    }else{
      $.ajax({
        url: apiUrl+'common/getUserFollow',
        type: 'post',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: (res)=>{
          console.log(res)
          if(res.code==200){
            // this.gettoken();
          }else if(res.code==101){
            console.log("未关注");
            outsideModel.getUserInfoAuthorization();
          }else{
            console.log(res.msg)
          }
        },
        error:(e)=>{
          console.log(e);
        }
      })
    }        
  };
module.exports = {
  outsideModel,
  isAuthorization
}
